import { FocusHandler, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { generateUntactDepartmentListItemFocusKey } from '@pages/Main/focuskey';
import * as styles from './styles';
import { useEffect } from 'react';

interface UntactDepartmentItemProps {
  index: number;
  name: string;
  imageUrl?: string;
  onFocus?: FocusHandler;
  onEnterPress?: () => void;
  hideAdvertisement: () => void;
}

const UntactDepartmentItem: React.FC<UntactDepartmentItemProps> = (props) => {
  const { index, name, imageUrl, onFocus, onEnterPress, hideAdvertisement } = props;

  const { ref, focused } = useFocusable({
    focusKey: generateUntactDepartmentListItemFocusKey(index),
    onFocus,
    onEnterPress
  });

  useEffect(() => {
    if (focused) {
      hideAdvertisement();
    }
  }, [focused]);

  return (
    <div css={[styles.container, focused && styles.focused]} ref={ref}>
      <img src={imageUrl} alt={name} css={[styles.icon, !focused && styles.inverted]} />
      <p css={[styles.text, focused && styles.focusedText]}>{name}</p>
    </div>
  );
};

export default UntactDepartmentItem;
